export default __webpack_public_path__ + "static/media/sideArrow.f82a712b.svg";